import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface Order {
  id: string;
  invId: string;
  merchantId: string;
  providerId?: string;
  type: string;
  status: string;
  currency: string;
  amount: number;
  factAmount?: number;
  exchangeRate?: number;
  usdtAmount?: number;
  merchantFee: number;
  providerFee: number;
  bank?: string;
  cardNumber?: string;
  phoneNumber?: string;
  accountNumber?: string;
  bankIdCode?: string;
  recipientFio?: string;
  isSbp: boolean;
  callbackUrl?: string;
  callbackSent: boolean;
  callbackAttempts: number;
  lastCallbackAt?: string;
  expiresAt?: string;
  completedAt?: string;
  metadata?: any;
  createdAt: string;
  updatedAt: string;
  provider?: {
    id: string;
    name: string;
  };
  merchant?: {
    id: string;
    displayName: string;
  };
}

interface OrderState {
  orders: Order[];
  currentOrder: Order | null;
  loading: boolean;
  error: string | null;
}

const initialState: OrderState = {
  orders: [],
  currentOrder: null,
  loading: false,
  error: null,
};

const orderSlice = createSlice({
  name: "order",
  initialState,
  reducers: {
    setOrders: (state, action: PayloadAction<Order[]>) => {
      state.orders = action.payload;
    },
    setCurrentOrder: (state, action: PayloadAction<Order>) => {
      state.currentOrder = action.payload;
    },
    addOrder: (state, action: PayloadAction<Order>) => {
      state.orders.push(action.payload);
    },
    updateOrder: (
      state,
      action: PayloadAction<Partial<Order> & { id: string }>
    ) => {
      const index = state.orders.findIndex((o) => o.id === action.payload.id);
      if (index !== -1) {
        state.orders[index] = { ...state.orders[index], ...action.payload };
      }
      if (state.currentOrder?.id === action.payload.id) {
        state.currentOrder = { ...state.currentOrder, ...action.payload };
      }
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
  },
});

export const {
  setOrders,
  setCurrentOrder,
  addOrder,
  updateOrder,
  setLoading,
  setError,
} = orderSlice.actions;

export default orderSlice.reducer;
